var _rect, _rect2, _rect3, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 9,
    rx: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19,
    width: 7,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 7,
    height: 2,
    rx: 1,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.5,
    r: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9003 13C25.0533 13.0836 25.7982 13.6858 25.9771 14.6853C25.9982 14.8039 25.9988 14.9268 25.9988 15.0476C25.9999 17.3512 26.0005 19.6549 25.9994 21.9585C25.9994 23.1758 25.1077 23.9996 23.7904 23.9996C20.5969 24.0001 17.4039 24.0001 14.2104 23.9996C12.8948 23.9991 12.0008 23.1737 12.0003 21.9585C11.9997 19.6753 12.0003 17.3916 12.0003 15.1085C12.0003 13.8718 12.7726 13.096 14.0999 13.0005C14.567 13.0005 15.0336 13.0005 15.5008 13.0005C16.4556 13.0027 17.4109 13.0065 18.3657 13.0065C19.7438 13.0065 21.1213 13.0027 22.4994 13.0005C22.9666 13.0005 23.4332 13.0005 23.9003 13.0005V13ZM18.3014 20.119C18.3014 20.3212 18.2997 20.5234 18.3014 20.725C18.3055 21.1196 18.6002 21.4097 18.996 21.4113C19.393 21.4129 19.6941 21.1239 19.6976 20.7315C19.7011 20.3541 19.7082 19.9767 19.6941 19.6004C19.6871 19.4236 19.7409 19.3368 19.9251 19.2564C20.7857 18.8807 21.2336 18.0213 21.0547 17.1399C20.8892 16.3237 20.0976 15.6611 19.21 15.5953C18.2272 15.5231 17.3595 16.0271 17.0285 16.8628C16.704 17.6811 16.9794 18.651 17.7986 19.0823C18.2739 19.333 18.3534 19.6209 18.3014 20.0376C18.2979 20.064 18.3014 20.0915 18.3014 20.1185V20.119Z",
    fill: "#F47226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4303 13C14.9541 13 14.4785 13 14.0023 13C14.0208 12.272 13.966 11.5426 14.0405 10.8159C14.2693 8.57728 15.7868 6.6949 17.7959 6.15893C20.6495 5.39716 23.4828 7.45344 23.9352 10.6225C24.0478 11.4103 23.9757 12.2071 23.9924 13C23.5162 13 23.0406 13 22.5644 13C22.5644 12.4978 22.562 11.9955 22.5656 11.4933C22.568 11.1838 22.5334 10.8795 22.4738 10.5778C22.1132 8.76091 20.5637 7.48718 18.8079 7.56245C17.145 7.63382 15.6807 9.09314 15.4703 10.8879C15.388 11.59 15.4482 12.296 15.4303 13Z",
    fill: "#F47226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDark);
export default __webpack_public_path__ + "static/media/lock_dark.8d9be3ab6a6c19e1f002a1f1fd7e9a25.svg";
export { ForwardRef as ReactComponent };